import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useTheme,
  alpha,
  Box
} from '@mui/material';
import { Phone, Close as CloseIcon } from '@mui/icons-material';
import ScheduleCallForm from './ScheduleCallForm';

const ScheduleCallModal = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* Button to open the modal */}
      <Button
        variant="contained"
        size="large"
        startIcon={<Phone />}
        onClick={handleOpen}
        sx={{
          bgcolor: '#FFFFFF',
          color: 'primary.main',
          px: 6,
          py: 2.5,
          fontSize: '1.2rem',
          fontWeight: 600,
          borderRadius: 3,
          boxShadow: `0 8px 32px ${alpha('#000000', 0.2)}`,
          '&:hover': {
            bgcolor: 'grey.100',
            transform: 'translateY(-3px)',
            boxShadow: `0 12px 40px ${alpha('#000000', 0.3)}`
          },
          transition: 'all 0.3s ease',
          textDecoration: 'none'
        }}
      >
        Schedule a Call
      </Button>

      {/* Modal Dialog */}
      <Dialog 
        open={open} 
        onClose={handleClose} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: `0 10px 40px ${alpha(theme.palette.primary.main, 0.2)}`,
          }
        }}
      >
        <DialogTitle sx={{ 
          textAlign: 'center', 
          pt: 4, 
          fontWeight: 700,
          fontSize: '1.8rem',
          color: theme.palette.primary.main,
          position: 'relative'
        }}>
          Schedule a Call With Us
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: { xs: 2, md: 4 }, pb: 4 }}>
          <Box sx={{ mt: 2 }}>
            <ScheduleCallForm inModal={true} onSuccess={handleClose} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ScheduleCallModal;
